import { Card, Col, Row } from "react-bootstrap";
import { IEpaCorrespondenceDetails } from "../../../api/IEpaCorrespondence";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { EPAInitiatedCorrespondenceIcon } from "../../../leap-components/icons/LeapIcons";

interface EpaCorrespondenceHeaderProps {
  epaCorrespondence: IEpaCorrespondenceDetails;
}

const EpaCorrespondenceHeader = ({
  epaCorrespondence,
}: EpaCorrespondenceHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <EPAInitiatedCorrespondenceIcon />
                  </td>
                  <td>
                    <h2>EPA Initiated Correspondence</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Reference No."} value={"n/a"} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={epaCorrespondence.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={epaCorrespondence.licenceDetails?.reg_no}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EpaCorrespondenceHeader;
